<template>
  <el-row>
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
      v-loading.fullscreen.lock="fullScreenLoading"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t('menu.reports.title') }}
        </h3>
      </el-header>
      <el-drawer
        :visible.sync="filterFormVisible"
        ref="filterFormDrawer"
        size="400"
      >
        <div class="demo-drawer__content pl-10 pr-10">
          <el-form
            ref="filterForm"
            :model="filter"
            :rules="getFormRules"
          >
            <el-row>
              <el-col
                :span="11"
              >
                <el-form-item
                  label="Start date"
                  prop="startDate"
                >
                  <el-date-picker
                    v-model="filter.startDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="{disabledDate: this.getStartDatePickerDisabledDates}"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-form-item
                  label="End date"
                  prop="endDate"
                >
                  <el-date-picker
                    v-model="filter.endDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="{disabledDate: this.getEndDatePickerDisabledDates}"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item
              v-if="$route.params.type === 'fn10' || $route.params.type === 'fn11'"
              label="QR Code"
              prop="qrCode"
            >
              <el-input-number
                :controls="false"
                v-model="filter.qrCode"
                placeholder="QR Code"
              />
            </el-form-item>
            <el-form-item
              v-if="$route.params.type === 'fn20'"
              :label="$t('menu.reports.max-amount')"
              prop="maxAmount"
            >
              <el-input-number
                :controls="false"
                v-model.number="filter.maxAmount"
                placeholder="Max EUR"
              />
            </el-form-item>
          </el-form>
          <div class="demo-drawer__footer mt-20">
            <el-row>
              <el-col :span="11">
                <el-button
                  class="cancel-button"
                  @click="resetFilters"
                >
                  {{ $t('form.reset') }}
                </el-button>
              </el-col>
              <el-col
                :span="11"
                :offset="2"
              >
                <el-button
                  type="primary"
                  class="primary-button"
                  @click="filterReport"
                >
                  {{ $t('menu.reports.filter') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-drawer>
      <el-row class="mt-15 pl-10 pr-10">
        <el-col
          :span="7"
        >
          <el-select
            v-model="reportFormat"
            placeholder="Format"
            @change="downloadReport"
            class="format-select"
          >
            <el-option
              label="PDF"
              value="pdf"
            />
            <el-option
              label="XLS"
              value="xlsx"
            />
          </el-select>
        </el-col>
        <el-col
          :span="7"
          :offset="10"
        >
          <el-button
            v-if="$route.params.type !== 'fn9' && $route.params.type !== 'fn8' && $route.params.type !== 'fn23'"
            type="primary"
            class="primary-button"
            @click="filterFormVisible = true"
          >
            Filter
          </el-button>
        </el-col>
      </el-row>
      <el-main>
        <div
          v-if="htmlReport"
          class="html"
          v-html="htmlReport"
        />
        <div
          v-if="!htmlReport"
          class="noReports"
        >
          <h1>{{ $t('menu.reports.no-payments') }}</h1>
        </div>
      </el-main>
    </el-col>
  </el-row>
</template>

<script>
import Menu from '@/views/Menu/Menu';

export default {
  name: 'Html',
  components: {
    Menu
  },
  data: () => ({
    fullScreenLoading: true,
    htmlReport: '',
    filter: {
      startDate: '',
      endDate: '',
      qrCode: undefined,
      maxAmount: undefined
    },
    reportFormat: '',
    filterFormVisible: false
  }),
  created () {
    this.getReport(this.$route.params.type);
  },
  watch: {
    $route: function (to, from) {
      if (to.params.type !== from.params.type) {
        this.getReport(to.params.type);
        if (this.$refs['filterForm']) {
          this.$refs['filterForm'].clearValidate();
        }
      }
    },
    currentLocale: function () {
      this.getReport(this.$route.params.type);
    }
  },
  computed: {
    getFormRules: function () {
      return {
        maxAmount: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('menu.reports.max-amount') }),
            trigger: 'blur'
          }
        ]
      };
    },
    currentLocale () {
      return this.$i18n.locale;
    }
  },
  methods: {
    getReport (type = '') {
      this.fullScreenLoading = true;
      this.$adminApi.get(`/api/v1/reports/html?report=${type}`).then((response) => {
        this.htmlReport = response.data;
        this.fullScreenLoading = false;
      }).catch(() => {
        this.fullScreenLoading = false;
      });
    },
    filterReport () {
      this.$refs['filterForm'].validate((valid) => {
        if (valid) {
          this.fullScreenLoading = true;
          this.$adminApi.get(`/api/v1/reports/html?report=${this.$route.params.type}`, {
            params: this.getFilterParams()
          }).then((response) => {
            this.htmlReport = response.data;
            this.fullScreenLoading = false;
          }).catch(() => {
            this.fullScreenLoading = false;
          });
          this.$refs.filterFormDrawer.closeDrawer();
        } else {
          return false;
        }
      });
    },
    resetFilters () {
      this.fullScreenLoading = true;
      this.filter = {
        startDate: '',
        endDate: '',
        qrCode: undefined,
        maxAmount: undefined
      };
      this.$adminApi.get('/api/v1/reports/html?report=' + this.$route.params.type).then((response) => {
        this.htmlReport = response.data;
        this.fullScreenLoading = false;
      }).catch(() => {
        this.fullScreenLoading = false;
      });
      this.$refs.filterFormDrawer.closeDrawer();
    },
    getFilterParams () {
      return {
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        qrCode: this.filter.qrCode || '',
        maxAmount: this.filter.maxAmount * 100 || ''
      };
    },
    downloadReport (format = '') {
      this.fullScreenLoading = true;
      this.$adminApi.get(`/api/v1/reports/${format}?report=${this.$route.params.type}`, {
        params: this.getFilterParams()
      }).then((response) => {
        if (response.data.length) {
          this.downloadPDF(response.data, format);
        }
        this.fullScreenLoading = false;
      }).catch(() => {
        this.fullScreenLoading = false;
      });
      this.reportFormat = '';
    },
    downloadPDF (pdf, format) {
      const linkSource = `data:application/${format};base64,${pdf}`;
      const downloadLink = document.createElement('a');
      const fileName = `${this.$route.params.type}_report.${format}`;

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      downloadLink.remove();
    },
    getStartDatePickerDisabledDates (date) {
      if (this.filter.endDate) {
        return new Date(this.filter.endDate) < date;
      }
      return false;
    },
    getEndDatePickerDisabledDates (date) {
      if (this.filter.startDate) {
        let today = new Date(this.filter.startDate);
        today.setDate(today.getDate() - 1);
        return today >= date;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.format-select {
  width: 100%;
}

.left-btn, .right-btn {
  @media(max-width: 1199px) {
    margin-top: 15px;
  }
}

.datepicker {
  @media(max-width: 1199px) {
    margin-bottom: 15px;
  }
}
</style>
